module.exports = __webpack_public_path__ + "static/media/susd.4302550f.png";